
// Utility functions for compliance calculations and display

// Get compliance status text based on score
export const getComplianceStatus = (score: number) => {
  if (score >= 80) return 'Compliant';
  if (score >= 60) return 'Needs Review';
  if (score >= 40) return 'At Risk';
  return 'Non-Compliant';
};

// Get compliance color based on score
export const getComplianceColor = (score: number) => {
  if (score >= 80) return 'text-green-500';
  if (score >= 60) return 'text-blue-500';
  if (score >= 40) return 'text-amber-500';
  return 'text-red-500';
};

// Get compliance icon based on score
export const getComplianceIcon = (score: number) => {
  // Note: This function is kept for completeness, but it's currently not used
  // in the refactored components directly. The icons are imported and used in the 
  // respective components that need them.
  if (score >= 80) return 'CheckCircle';
  if (score >= 60) return 'AlertTriangle';
  if (score >= 40) return 'AlertTriangle';
  return 'XCircle';
};

// Get risk level based on compliance score
export const getRiskLevel = (score: number) => {
  if (score >= 80) return 'Low Risk';
  if (score >= 60) return 'Low Risk';
  if (score >= 40) return 'Medium Risk';
  return 'High Risk';
};

// Get recommended policy based on inactivity
export const getRecommendedPolicy = (inactivityStats: number, inactivityThreshold: number) => {
  if (inactivityStats > inactivityThreshold) {
    return { id: 2, name: 'Cleanup' }; // Using a real policy ID
  } else if (inactivityStats > inactivityThreshold * 0.8) {
    return { id: 3, name: 'Archive' };
  }
  return { id: 1, name: 'Review' };
};
